
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useLocale from 'next-translate/useTranslation';
import clsxm from '@/lib/clsxm';
import AgentActions from '@/components/agents/AgentActions';
import AgentChannels from '@/components/agents/AgentChannels';
import AgentControl from '@/components/agents/AgentControl';
import AgentFaq from '@/components/agents/AgentFaq';
import AgentFinalCta from '@/components/agents/AgentFinalCta';
import AgentIndustries from '@/components/agents/AgentIndustries';
import AgentInsights from '@/components/agents/AgentInsights';
import AgentKnowledge from '@/components/agents/AgentKnowledge';
import AgentLogos from '@/components/agents/AgentLogos';
import AgentPricing from '@/components/agents/AgentPricing';
import AgentReviews from '@/components/agents/AgentReviews';
import AgentsHero from '@/components/agents/AgentsHero';
import AgentVoice from '@/components/agents/AgentVoice';
import { tone } from '@/components/agents/primitives';
import Footer from '@/components/layout/Footer';
import Seo from '@/components/Seo';
/*
 * The AI Agents landing page. Story: one agent that knows your business
 * (knowledge), acts on it (actions), talks (voice) on every channel, stays
 * under your control, and improves from every conversation. Then proof,
 * price and questions.
 */
export default function ChatBots() {
    const { t, lang } = useLocale('chatbots');
    return (
    // `relative` makes <main> the containing block of the footer's sr-only
    // heading, so overflow-x-clip catches the 1px it pokes out in RTL.
    <main className={clsxm('relative overflow-x-clip', tone.page)} dir={lang === 'ar' ? 'rtl' : undefined}>
      {/* The support chat bubble is mounted site-wide by SiteChatWidget (_app);
            the "Talk to our agent" buttons open it. */}
      <Seo templateTitle={t('AI Agents | Build Custom AI Agents Trained on Your Data')} description={t('Build AI agents trained on your data and put them on your website, WhatsApp, email and the phone. Support, sales and lead capture, around the clock.')} image={`https://easy-peasy.ai/api/og-template?title=${t('AI Agents Trained on Your Data')}`}/>
      <AgentsHero />
      <AgentLogos />
      <AgentKnowledge />
      <AgentActions />
      <AgentVoice />
      <AgentChannels />
      <AgentControl />
      <AgentInsights />
      <AgentIndustries />
      <AgentReviews />
      <AgentPricing />
      <AgentFaq />
      <AgentFinalCta />
      <Footer />
    </main>);
}

    async function __Next_Translate__getStaticProps__1a0fb05456c__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/chatbots/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0fb05456c__ as getStaticProps }
  